'use client';

export default function IconCart(props: any) {
    return <div className="editor-shopify-card-right-icon" {...props}></div>;
}
